import { useTranslation } from 'react-i18next';
import { Confirmation } from '@otp/ui';
import {
  LmsCertificate,
  LmsCertificatesDocument,
} from 'src/graphql/generated/graphql';
import React from 'react';
import { DocumentNode } from '@apollo/client';
import { DeleteConfirmationCheckModal } from 'src/components/common/modals/delete-confirmation-check';
import { EntityAction } from 'src/components/lms/certificates/list/table/columns/types';
import { useLmsCertificateUpdate } from 'src/hooks/query/lms/certificates/use-certificate-update';

export const DeleteModals = ({
  action,
  onClose,
  entity,
  onFinish,
  refetchQueries,
}: {
  action: EntityAction;
  onClose: () => void;
  onSubmitted?: (action: EntityAction) => void;
  entity: LmsCertificate;
  onFinish: () => void;
  refetchQueries?: DocumentNode[];
}) => {
  const { t } = useTranslation();

  const [updateEntity] = useLmsCertificateUpdate(
    refetchQueries || [LmsCertificatesDocument],
  );

  const onEntityDeleteToggle = async (toDelete: boolean) => {
    await updateEntity({
      variables: {
        id: entity.id,
        data: {
          isDeleted: toDelete,
        },
      },
    });
    onFinish();
  };

  return (
    <>
      {action === EntityAction.Delete && (
        <DeleteConfirmationCheckModal
          onClose={onClose}
          onConfirm={() => onEntityDeleteToggle(true)}
          message={t('lms.certificates.delete-confirm')}
        />
      )}
      {action === EntityAction.Restore && (
        <Confirmation
          open
          onClose={onClose}
          onConfirm={() => onEntityDeleteToggle(false)}
          message={t('lms.certificates.restore-confirm')}
        />
      )}
    </>
  );
};
